import React from 'react'

import globalNotification from 'live/services/global-notification'

import { GlobalNotification } from '../global-components/GlobalNotification'
import i18n from 'live/services/i18n'
import _ from 'lodash'

function handleFetchErrors(response: Response): Promise<any> {
    if (!response.ok) {
        return Promise.reject(response)
    }

    return Promise.resolve(response)
}

export function fetchCodafEntity(entityName: string): Promise<WellType[]> {
    return fetch(`/services/plugin-static-data-manager/${entityName}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => {
            return r.text().then(data => {
                return JSON.parse(data)
            })
        })
        .catch(() => {
            globalNotification.error(
                <GlobalNotification title={`Unable to get codaf ${entityName}`} type="error" />,
                10
            )

            return null
        })
}

export function createWellOnCodaf(body: any): Promise<WellType> {
    return fetch(`/services/plugin-static-data-manager/well/create`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    })
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            return res.body
        })
        .catch((err: Response) => {
            console.error(err)
        })
}

export function deleteWellFromCodaf(id: number): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/well/${id}/`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    }).catch(err => {
        console.error(err)
    })
}

export function updateWellFromCodaf(body: any): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/well/update`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    })
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            return res.body
        })
        .catch((err: Response) => {
            console.error(err)
        })
}

export const fetchUnitOptions: (type: string) => Promise<{ options: Uom[] }> = _.memoize(type => {
    return fetch(`/services/plugin-static-data-manager/query/getUnitsOptions/${type}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            return res.body
        })
        .catch(() => {
            globalNotification.error(i18n(`Unable to fetch unities for type.`))

            return null
        })
})
